var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseOutline = function SvgPauseOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85 5.298v13.404c0 .714.532 1.298 1.182 1.298h1.901c.65 0 1.183-.584 1.183-1.298V5.298C10.116 4.584 9.584 4 8.933 4h-1.9c-.651 0-1.184.584-1.184 1.298ZM7.031 19c-.076 0-.183-.117-.183-.298V5.298c0-.181.107-.298.183-.298h1.901c.077 0 .183.117.183.298v13.404c0 .181-.106.298-.183.298h-1.9Zm8.035-15h1.9c.651 0 1.183.584 1.183 1.298v13.404c0 .714-.532 1.298-1.182 1.298h-1.901c-.65 0-1.183-.584-1.183-1.298V5.298c0-.714.532-1.298 1.183-1.298Zm-.183 1.298c0-.181.106-.298.183-.298h1.9c.077 0 .183.117.183.298v13.404c0 .181-.106.298-.182.298h-1.901c-.077 0-.183-.117-.183-.298V5.298Z",
    fill: "currentColor"
  })));
};
export default SvgPauseOutline;